import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/Index.vue'),
    children:[
      {
        path: '/projectList',
        name: 'projectList',
        component: () => import('@/views/merchant/ProjectList.vue'),
      },
      {
        path: '/projectListAdd',
        name: 'projectListAdd',
        component: () => import('@/views/merchant/ProjectListAdd.vue'),
      },
      {
        path: '/projectTypeList',
        name: 'projectTypeList',
        component: () => import('@/views/merchant/ProjectTypeList.vue'),
      },
      {
        path: '/projectListCustomer',
        name: 'projectListCustomer',
        component: () => import('@/views/merchant/ProjectListCustomer.vue'),
      },
      {
        path: '/customerList',
        name: 'customerList',
        component: () => import('@/views/merchant/CustomerList.vue'),
      },
      {
        path: '/customerListAdd',
        name: 'customerListAdd',
        component: () => import('@/views/merchant/CustomerListAdd.vue'),
      },
      {
        path: '/customerListEdit',
        name: 'customerListEdit',
        component: () => import('@/views/merchant/CustomerListEdit.vue'),
      },
      {
        path: '/customerListRecharge',
        name: 'customerListRecharge',
        component: () => import('@/views/merchant/CustomerListRecharge.vue'),
      },
      {
        path: '/customerListView',
        name: 'customerListView',
        component: () => import('@/views/merchant/CustomerListView.vue'),
      },
      {
        path: '/employeeList',
        name: 'employeeList',
        component: () => import('@/views/merchant/EmployeeList.vue'),
      },
      {
        path: '/employeeListAdd',
        name: 'employeeListAdd',
        component: () => import('@/views/merchant/EmployeeListAdd.vue'),
      },
      {
        path: '/employeeRoleList',
        name: 'employeeRoleList',
        component: () => import('@/views/merchant/EmployeeRoleList.vue'),
      },
      {
        path: '/signList',
        name: 'signList',
        component: () => import('@/views/merchant/SignList.vue'),
      },
      {
        path: '/operationList',
        name: 'operationList',
        component: () => import('@/views/merchant/OperationList.vue'),
      },
      {
        path: '/noticeList',
        name: 'noticeList',
        component: () => import('@/views/merchant/NoticeList.vue'),
      },
      {
        path: '/overviewList',
        name: 'overviewList',
        component: () => import('@/views/merchant/OverviewList.vue'),
      },
      {
        path: '/employeeView',
        name: 'employeeView',
        component: () => import('@/views/merchant/EmployeeView.vue'),
      },
      {
        path: '/stockList',
        name: 'stockList',
        component: () => import('@/views/merchant/StockList.vue'),
      },
      {
        path: '/stockTaking',
        name: 'stockTaking',
        component: () => import('@/views/merchant/StockTaking.vue'),
      },
      {
        path: '/timetableList',
        name: 'timetableList',
        component: () => import('@/views/merchant/TimetableList.vue'),
      },
      {
        path: '/timetableTime',
        name: 'timetableTime',
        component: () => import('@/views/merchant/TimetableTime.vue'),
      },
      {
        path: '/timetableRoom',
        name: 'timetableRoom',
        component: () => import('@/views/merchant/TimetableRoom.vue'),
      },
      {
        path: '/timetableInfo',
        name: 'timetableInfo',
        component: () => import('@/views/merchant/TimetableInfo.vue'),
      },
      {
        path: '/statisticList',
        name: 'statisticList',
        component: () => import('@/views/merchant/StatisticList.vue'),
      },
      {
        path: '/cardLowList',
        name: 'cardLowList',
        component: () => import('@/views/merchant/CardLowList.vue'),
      },
      {
        path: '/rechargeList',
        name: 'rechargeList',
        component: () => import('@/views/merchant/RechargeList.vue'),
      },
    ],
  }
];

const router = createRouter({
  routes,
  // history: createWebHistory(process.env.BASE_URL),
  // 部署在springboot中用hash模式
  history: createWebHashHistory(process.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 }
  }
});

router.beforeEach((to, from, next)=>{
  const userInfoItem = localStorage.getItem("userInfo");
  if(userInfoItem && userInfoItem != 'undefined' && userInfoItem != 'null' && to.path === '/') {  //token存在时候，进去登录页面就自动跳转到首页
      const userInfo = JSON.parse(userInfoItem);
      if(userInfo.myShopList && userInfo.myShopList.length > 0){
        next("/index")
      }else{
        next();
      }
  }else {
      next()
  }
});

export default router
